import { useEffect } from "react";
import { Dialog } from "primereact/dialog";
import ModalCloseButton from "./ModalCloseButton";
import Button, { ButtonType } from "../Button";
import "./Modal.scss";
import { getSizeClass } from "./ModalSizeClasses";

const MultiStepModal = ({ title, showModal, steps, step, content, size, modalButtons, hideCancel, back, close }) => {
	const header = (
		<div className="modal-header">
			<ModalCloseButton close={close} back={back} step={step} hideClose={hideCancel} />
			<h1>{title}</h1>
		</div>
	);

	const footer = (
		<div>
			{!hideCancel && <Button type={ButtonType.Tertiary} label={"Cancel"} onClick={close} />}
			{modalButtons}
		</div>
	);

	const sizeClass = getSizeClass(size);

	useEffect(() => {
		if (showModal) {
			document.body.classList.add("body-no-scroll");
		} else {
			document.body.classList.remove("body-no-scroll");
		}
		return () => {
			document.body.classList.remove("body-no-scroll");
		};
	}, [showModal]);

	if (content) {
		return (
			<Dialog id="uc-modal" className={sizeClass} position="center" closable={false} visible={showModal} header={header} footer={footer} onHide={close}>
				<div className="body">
					{steps > 1 ? <h2>Step {step + 1} of {steps}: {content.props.title}</h2> : <h2>{content.props.title}</h2>}
					{content}
				</div>
			</Dialog>
		);
	} else {
		title = "No Modal Content";
		return (
			<Dialog id="uc-modal" className="gutters" position="center" visible={showModal} header={header} footer={footer} onHide={close} />
		);
	}
};

export default MultiStepModal;
